export const CHROMATIC_SHARP = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'] as const;
export const CHROMATIC_FLAT  = ['C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B'] as const;

// Canonical spelling for each chromatic root (flat wins at 6+ accidentals)
// Used by transposeNote to produce correctly-spelled output
export const ENHARMONIC_CANONICAL: Record<string, string> = {
  'C#': 'Db',
  'D#': 'Eb',
  'F#': 'F#',  // F# is preferred over Gb
  'G#': 'Ab',
  'A#': 'Bb',
};

// Which keys use sharps vs flats
export const SHARP_KEYS = new Set(['G', 'D', 'A', 'E', 'B', 'F#']);
export const FLAT_KEYS  = new Set(['F', 'Bb', 'Eb', 'Ab', 'Db', 'Gb']);

// The 12 chromatic roots in display order for the Circle of Fifths (clockwise from C)
export const CIRCLE_OF_FIFTHS_MAJOR = ['C', 'G', 'D', 'A', 'E', 'B', 'F#', 'Db', 'Ab', 'Eb', 'Bb', 'F'] as const;
export const CIRCLE_OF_FIFTHS_MINOR = ['A', 'E', 'B', 'F#', 'C#', 'G#', 'Eb', 'Bb', 'F', 'C', 'G', 'D'] as const;

export type NoteName = typeof CHROMATIC_SHARP[number] | typeof CHROMATIC_FLAT[number];
